export enum RequestExcusableOrderType {
  Pbh = 0,
  Rbh = 1,
}
